// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","name-of-animation":"Loader_name-of-animation__TXksy"};